<mat-drawer-container [hasBackdrop]="false">
  <mat-drawer
    mode="side"
    position="end"
    mode="over"
    class="hang-drawer"
    [ngClass]="store.drawerWidth()"
    [class.edit-mode]="store.mode() === 'edit'"
    [class.whole-page]="store.pageLayout() === PageLayout.WHOLE_PAGE"
    [opened]="$visible()"
    disableClose
  >
    @defer (when $visible()) {
      @if ($visible()) {
        <hang-form
          #hangForm
          [parentOverlayType]="HangFormOverlayType.DRAWER"
          (created)="handleCreated($event)"
          (updated)="handleUpdated($event)"
          (cancel)="handleCancel()"
          (viewChange)="$formView.set($event)"
          (pendingHang)="$formPendingHang.set($event)"
          [hang]="store.formInputHang() ?? undefined"
          [timespan]="store.formInputTimespan() ?? undefined"
          [pueblo]="store.formInputPueblo() ?? undefined"
          [compact]="true"
          [showFormTitle]="store.pageLayout() !== PageLayout.WHOLE_PAGE"
          (changesMade)="store.setChangesMade($event)"
        ></hang-form>
      }
    }
  </mat-drawer>
  <mat-drawer-content>
    <ng-content></ng-content>
  </mat-drawer-content>
</mat-drawer-container>
